// extracted by mini-css-extract-plugin
export default {"modals":"ModalsDeletePost_modals__YAlPL","block":"ModalsDeletePost_block__0vavr","text":"ModalsDeletePost_text__IZk4s"};